export const PhoneMockup = ({ src, alt, className = "", testId }) => (
  <div
    data-testid={testId}
    className={`relative overflow-hidden rounded-[2.5rem] border-[10px] border-slate-900 bg-slate-900 shadow-[0_30px_60px_-15px_rgba(15,23,42,0.35)] ${className}`}
  >
    <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-slate-900" />
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="block h-full w-full rounded-[1.9rem] object-cover object-top"
    />
  </div>
);
